import { render } from "./UPSHeader.vue?vue&type=template&id=c475d3d2&scoped=true"
import script from "./UPSHeader.vue?vue&type=script&lang=js"
export * from "./UPSHeader.vue?vue&type=script&lang=js"

import "./UPSHeader.vue?vue&type=style&index=0&id=c475d3d2&lang=scss&scoped=true"
import "./UPSHeader.vue?vue&type=style&index=1&id=c475d3d2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c475d3d2"]])

export default __exports__